import script from "./chapter10.vue?vue&type=script&setup=true&lang=js"
export * from "./chapter10.vue?vue&type=script&setup=true&lang=js"

import "./chapter10.vue?vue&type=style&index=0&id=b43f7c58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b43f7c58"]])

export default __exports__